import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router';
import PaginationPanel from '@components/PaginationPanel/PaginationPanel';
import SearchPanel from '@src/components/SearchPanel/SearchPanel';
import Table from './Table/Table';
import axiosInstance from '@src/axios-instance';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import Select from 'react-select';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';

class EvidenceOfInsurance extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phraze: '',
      loaded: false,
      pagination: {
        associations: [],
        loaded: false,
        list: [],
        total: 0,
        page: 1,
        limit: 50,
        start: 0,
        end: 50,
        sort: null,
        direction: null,
        phraze: ''
      },
      conditions: {
        date_from: moment().subtract(6, 'months'),
        date_to: moment(),
        association_id: null,
        type: 0,
        status: 0,
        pre_pay: 0
      }
    };

    const { page, limit, sort, direction, phraze } = this.state.pagination;
    this.getList({ page, limit, sort, direction, phraze });
  }

  resetFilter = () => {
    this.setState(
      {
        phraze: '',
        pagination: {
          associations: [],
          loaded: false,
          list: [],
          total: 0,
          page: 1,
          limit: 10,
          start: 0,
          end: 10,
          sort: null,
          direction: null,
          phraze: ''
        },
        conditions: {
          date_from: moment().subtract(6, 'months'),
          date_to: moment(),
          association_id: null,
          type: 0,
          status: 0,
          pre_pay: 0
        }
      },
      () => {
        const { limit, sort, direction, phraze } = this.state.pagination;
        this.getList({ page: 1, limit, sort, direction, phraze });
      }
    );
  };

  getList = getData => {
    const conditions = { ...this.state.conditions };
    conditions.date_from = conditions.date_from.format('YYYY-MM-DD');
    conditions.date_to = conditions.date_to.format('YYYY-MM-DD');
    axiosInstance()
      .get('/evidence-of-insurances.json', {
        params: { ...getData, ...conditions }
      })
      .then(response => {
        this.setState({ pagination: { ...response.data }, loaded: true });
      })
      .catch(err => {
        alert(err);
      });
  };

  onEvidenceClick = entityId => {
    this.props.history.push(`/eois/${entityId}`);
  };

  searchTimeout: null;
  onSearch = value => {
    clearTimeout(this.searchTimeout);
    this.setState({
      phraze: value
    });

    const { limit, sort, direction } = this.state.pagination;
    this.searchTimeout = setTimeout(
      () =>
        this.getList({
          phraze: value,
          limit: limit,
          sort: sort,
          direction: direction
        }),
      1000
    );
  };

  updateForm = (event, name) => {
    const value =
      event !== null && event.target !== undefined ? event.target.value : event;

    const conditions = JSON.parse(JSON.stringify(this.state.conditions));
    conditions.date_from = this.state.conditions.date_from;
    conditions.date_to = this.state.conditions.date_to;
    conditions[name] = value;

    this.setState(
      {
        conditions: conditions
      },
      () => {
        const { limit, sort, direction } = this.state.pagination;
        this.getList({ page: 1, limit, sort, direction });
      }
    );
  };

  render = () => {
    const {
      page,
      limit,
      total,
      start,
      end,
      sort,
      direction,
      phraze
    } = this.state.pagination;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | EOIs</title>
        </Helmet>
        <h3>
          Evidence Of Insurance
          <Button
            className={'float-right'}
            size={'sm'}
            color={'primary'}
            onClick={this.resetFilter}
          >
            Reset
          </Button>
        </h3>
        {this.state.loaded && (
          <div>
            <SearchPanel
              showFilter={false}
              searchValue={this.state.phraze}
              onSearchChange={phraze => this.onSearch(phraze)}
              searchPlaceholder={
                'Search by Association name, Reference #, Invoice #, Homeowner or Property Address'
              }
            />
            <Row className={'pt-3'}>
              <Col className={'pr-1'}>
                <div className={'form-group'}>
                  <label className={'font-weight-bold'}>
                    Issue Date - From
                  </label>
                  <div>
                    <SingleDatePicker
                      date={this.state.conditions.date_from} // momentPropTypes.momentObj or null
                      onDateChange={startDate =>
                        this.updateForm(startDate, 'date_from')
                      } // PropTypes.func.isRequired
                      focused={this.state.issueDateFocused} // PropTypes.bool
                      block={true}
                      isOutsideRange={() => false}
                      onFocusChange={({ focused }) =>
                        this.setState({ issueDateFocused: focused })
                      } // PropTypes.func.isRequired
                      id="issue-date-from" // PropTypes.string.isRequired,
                    />
                  </div>
                </div>
              </Col>
              <Col className={'px-1'}>
                <div className={'form-group'}>
                  <label className={'font-weight-bold'}>Issue Date - To</label>
                  <div>
                    <SingleDatePicker
                      date={this.state.conditions.date_to} // momentPropTypes.momentObj or null
                      onDateChange={startDate =>
                        this.updateForm(startDate, 'date_to')
                      } // PropTypes.func.isRequired
                      focused={this.state.studyDateToFocused} // PropTypes.bool
                      block={true}
                      isOutsideRange={() => false}
                      onFocusChange={({ focused }) =>
                        this.setState({ studyDateToFocused: focused })
                      } // PropTypes.func.isRequired
                      id="study-date-from" // PropTypes.string.isRequired,
                    />
                  </div>
                </div>
              </Col>
              <Col className={'px-1'}>
                <div className={'form-group'}>
                  <label className={'font-weight-bold'}>Association</label>
                  <Select
                    value={
                      this.state.conditions.association_id !== null
                        ? {
                            value: this.state.conditions.association_id,
                            label: this.state.pagination.associations.find(
                              item =>
                                item.value ===
                                this.state.conditions.association_id
                            ).label
                          }
                        : null
                    }
                    options={this.state.pagination.associations}
                    menuPlacement={'auto'}
                    isClearable={true}
                    onChange={event => {
                      this.updateForm(
                        event === null ? null : event.value,
                        'association_id'
                      );
                    }}
                  />
                </div>
              </Col>
              <Col className={'px-1'}>
                <div className={'form-group'}>
                  <label className="font-weight-bold">EOI Type</label>
                  <select
                    className={'form-control'}
                    value={this.state.conditions.type}
                    onChange={event => this.updateForm(event, 'type')}
                  >
                    <option value={'0'}>All</option>
                    {EOITypes.map(item => {
                      return (
                        <option key={item.key} value={item.key}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Col>
              <Col className={'px-1'}>
                <div className={'form-group'}>
                  <label className="font-weight-bold">Status</label>
                  <select
                    className={'form-control'}
                    value={this.state.conditions.status}
                    onChange={event => this.updateForm(event, 'status')}
                  >
                    <option value={'0'}>All</option>
                    <option value={'requested'}>Submitted</option>
                    <option value={'approved'}>Approved</option>
                    <option value={'invoiced'}>Invoiced</option>
                    <option value={'paid'}>Paid</option>
                    <option value={'delivered'}>Delivered</option>
                    <option value={'pending'}>Pending</option>
                    <option value={'onhold'}>On Hold - Internal</option>
                    <option value={'denied'}>Denied</option>
                  </select>
                </div>
              </Col>
              <Col className={'pl-1'}>
                <div className={'form-group'}>
                  <label className="font-weight-bold">Pre-pay</label>
                  <select
                    className={'form-control'}
                    value={this.state.conditions.pre_pay}
                    onChange={event => this.updateForm(event, 'pre_pay')}
                  >
                    <option value={'0'}>All</option>
                    <option value={'yes'}>Yes</option>
                    <option value={'no'}>No</option>
                  </select>
                </div>
              </Col>
            </Row>
            <Table
              {...this.state.pagination}
              onEntityClick={this.onEvidenceClick}
              paginationFunc={this.getList}
            />
            <PaginationPanel
              page={page}
              limit={limit}
              total={total}
              start={start}
              end={end}
              sort={sort}
              direction={direction}
              paginationFunc={this.getList}
              phraze={phraze}
            />
          </div>
        )}
      </Container>
    );
  };
}

export default withRouter(EvidenceOfInsurance);
